var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeobase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 243.24001,
    height: 68.346664,
    viewBox: "0 0 243.24001 68.346664",
    sodipodiNocname: "neobase.eps",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78.418,327.344 V 113.746 H 39.2109 V 472.461 L 0,510.348 V 75.8281 h 227.813 l -39.227,37.9179 h -70.859 v 122.055 l 33.043,-31.953 6.152,-5.93 8.691,-8.402 156.84,-151.6019 H 156.84 L 195.223,0 h 221.789 z",
    id: "path16"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(417.013,0,0,403.078,0,255.173)",
    spreadMethod: "pad",
    id: "linearGradient32"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop20"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f7d307"
    },
    offset: 0.02,
    id: "stop22"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#e0bb10"
    },
    offset: 0.22,
    id: "stop24"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d1aa15"
    },
    offset: 0.43,
    id: "stop26"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c8a11f"
    },
    offset: 0.68,
    id: "stop28"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop30"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 376.605,185.336 v 213.609 h 39.227 V 40.2148 L 455.023,2.33203 V 436.848 H 227.309 l 39.211,-37.903 h 70.875 V 276.891 L 132.668,474.73 h 165.535 l -38.402,37.915 H 38.0117 Z",
    id: "path40"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(417.013,0,0,403.078,38.0118,257.489)",
    spreadMethod: "pad",
    id: "linearGradient56"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop44"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f7d307"
    },
    offset: 0.02,
    id: "stop46"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#e0bb10"
    },
    offset: 0.22,
    id: "stop48"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d1aa15"
    },
    offset: 0.43,
    id: "stop50"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c8a11f"
    },
    offset: 0.68,
    id: "stop52"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop54"
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 383.031,80.9805 73.8711,380.059 71.9922,431.715 381.172,132.617 Z",
    id: "path64"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(221.773,-210.795,218.082,214.363,120.964,357.62)",
    spreadMethod: "pad",
    id: "linearGradient80"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop68"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f7d307"
    },
    offset: 0.02,
    id: "stop70"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#e0bb10"
    },
    offset: 0.22,
    id: "stop72"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d1aa15"
    },
    offset: 0.43,
    id: "stop74"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c8a11f"
    },
    offset: 0.68,
    id: "stop76"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop78"
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 701.414,146.488 592.418,269.691 V 155.613 c 0.441,-7.437 -5.441,-13.812 -13.137,-14.238 -7.691,-0.426 -14.289,5.258 -14.726,12.695 -0.032,0.516 -0.032,1.028 0,1.543 v 150.36 c 0,10.402 14.136,20.718 26.402,6.832 L 697.992,191.801 v 114.172 c -0.441,7.437 5.442,13.808 13.137,14.238 7.691,0.426 14.289,-5.262 14.726,-12.699 0.032,-0.512 0.032,-1.028 0,-1.539 v -150.36 c -0.031,-5.234 -3.167,-9.984 -8.07,-12.211 -5.551,-2.679 -12.269,-1.414 -16.371,3.086 z",
    id: "path88"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(925.319,-440.588,455.819,894.4,695.259,206.959)",
    spreadMethod: "pad",
    id: "linearGradient96"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop92"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop94"
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 901.297,142.211 H 759.926 V 244.785 H 901.297 V 216.93 H 788.883 v -46.594 h 112.414 z m 0,177.293 V 291.383 H 759.926 v 28.121 z",
    id: "path104"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(925.319,-440.588,455.819,894.4,731.492,278.053)",
    spreadMethod: "pad",
    id: "linearGradient112"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop108"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop110"
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1023.93,294.949 c -36.621,0 -66.309,-28.691 -66.309,-64.09 0,-35.398 29.688,-64.093 66.309,-64.093 36.62,0 66.31,28.695 66.31,64.093 0.05,35.348 -29.56,64.043 -66.13,64.09 -0.06,0 -0.12,0 -0.18,0 z m 96.45,-64.09 c 0,-51.492 -43.18,-93.23 -96.45,-93.23 -53.27,0 -96.453,41.738 -96.453,93.23 0,51.489 43.183,93.231 96.453,93.231 53.25,-0.051 96.4,-41.762 96.45,-93.231 z",
    id: "path120"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(925.319,-440.588,455.819,894.4,769.235,352.113)",
    spreadMethod: "pad",
    id: "linearGradient128"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop124"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop126"
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1259.25,169.145 c 13.79,-0.571 25.45,9.773 26.04,23.101 0.59,13.328 -10.12,24.598 -23.91,25.168 -0.71,0.027 -1.42,0.027 -2.13,0 h -80.58 v -48.269 z m 0,150.359 c 29.14,0.035 52.79,-22.774 52.83,-50.938 0.02,-14.343 -6.21,-28.031 -17.17,-37.707 21.51,-19.004 23.01,-51.265 3.35,-72.054 -10.01,-10.586 -24.17,-16.61 -39.01,-16.594 h -94.54 c -7.69,0 -13.93,6.012 -13.95,13.445 v 75.203 c 0.02,7.438 6.25,13.461 13.95,13.489 h 94.54 c 13.78,0.015 24.93,10.824 24.91,24.14 -0.01,13.293 -11.16,24.067 -24.91,24.082 h -94.54 c -7.69,-0.425 -14.29,5.258 -14.73,12.696 -0.44,7.437 5.44,13.812 13.14,14.238 0.53,0.031 1.06,0.031 1.59,0 z",
    id: "path136"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(925.319,-440.588,455.819,894.4,806.855,425.929)",
    spreadMethod: "pad",
    id: "linearGradient144"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop140"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop142"
  })), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1334.22,160.988 c 9.85,21.735 61.52,144.809 72.52,154.946 2.15,2.152 5.07,3.429 8.16,3.57 3.1,-0.121 6.02,-1.402 8.16,-3.57 11.04,-10.137 62.66,-133.211 72.51,-154.946 7.35,-16.218 -18.24,-26.933 -25.44,-10.754 l -55.23,121.84 -55.18,-121.84 c -7.35,-16.179 -32.84,-5.464 -25.5,10.754 z",
    id: "path152"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(925.319,-440.588,455.819,894.4,838.898,488.804)",
    spreadMethod: "pad",
    id: "linearGradient160"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop156"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop158"
  })), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1629.83,281.508 c -12.41,10.551 -28.54,16.09 -45.05,15.472 -5.27,-0.429 -10.41,-1.71 -15.24,-3.792 -4.05,-1.735 -7.64,-4.344 -10.49,-7.625 -4.2,-4.754 -6.18,-10.977 -5.47,-17.192 2.6,-14.195 22.26,-19.793 41.91,-25.082 32.52,-9.125 64.72,-17.984 60.79,-59.555 v -0.218 c -1.2,-8.786 -4.83,-17.094 -10.49,-24.071 -7.46,-8.465 -17.27,-14.703 -28.27,-17.984 -11.9,-3.438 -24.43,-4.313 -36.71,-2.555 -23.86,3.199 -46.29,12.86 -64.71,27.86 l 18.24,22.039 c 14.27,-11.43 31.54,-18.813 49.89,-21.336 8.13,-1.231 16.45,-0.719 24.35,1.5 5.55,1.476 10.49,4.554 14.18,8.816 2.32,2.649 3.78,5.899 4.2,9.344 1.28,17.633 -18.88,23.32 -39.58,29.137 -29.1,7.847 -58.42,16.222 -63.17,49.418 v 1.011 c -1.1,13.645 3.32,27.168 12.32,37.735 5.69,6.261 12.64,11.347 20.43,14.941 8.13,3.535 16.83,5.684 25.72,6.348 24.13,1.211 47.81,-6.692 66.03,-22.039 z",
    id: "path168"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(925.319,-440.588,455.819,894.4,879.951,569.357)",
    spreadMethod: "pad",
    id: "linearGradient176"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop172"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop174"
  })), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath186"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1824 V 513 H 0 Z",
    id: "path184"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1824.29,142.211 h -141.37 v 102.574 h 141.37 V 216.93 h -112.46 v -46.594 h 112.46 z m 0,177.293 v -28.121 h -141.37 v 28.121 z",
    id: "path190"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(925.319,-440.588,455.819,894.4,911.73,631.714)",
    spreadMethod: "pad",
    id: "linearGradient198"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f9d606"
    },
    offset: 0,
    id: "stop194"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c69e21"
    },
    offset: 1,
    id: "stop196"
  }))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,68.346667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78.418,327.344 V 113.746 H 39.2109 V 472.461 L 0,510.348 V 75.8281 h 227.813 l -39.227,37.9179 h -70.859 v 122.055 l 33.043,-31.953 6.152,-5.93 8.691,-8.402 156.84,-151.6019 H 156.84 L 195.223,0 H 417.012 L 78.418,327.344",
    style: {
      fill: "url(#linearGradient32)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g38",
    clipPath: "url(#clipPath42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 376.605,185.336 v 213.609 h 39.227 V 40.2148 L 455.023,2.33203 V 436.848 H 227.309 l 39.211,-37.903 h 70.875 V 276.891 L 132.668,474.73 h 165.535 l -38.402,37.915 H 38.0117 L 376.605,185.336",
    style: {
      fill: "url(#linearGradient56)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62",
    clipPath: "url(#clipPath66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 383.031,80.9805 73.8711,380.059 71.9922,431.715 381.172,132.617 383.031,80.9805",
    style: {
      fill: "url(#linearGradient80)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g86",
    clipPath: "url(#clipPath90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 701.414,146.488 592.418,269.691 V 155.613 c 0.441,-7.437 -5.441,-13.812 -13.137,-14.238 -7.691,-0.426 -14.289,5.258 -14.726,12.695 -0.032,0.516 -0.032,1.028 0,1.543 v 150.36 c 0,10.402 14.136,20.718 26.402,6.832 L 697.992,191.801 v 114.172 c -0.441,7.437 5.442,13.808 13.137,14.238 7.691,0.426 14.289,-5.262 14.726,-12.699 0.032,-0.512 0.032,-1.028 0,-1.539 v -150.36 c -0.031,-5.234 -3.167,-9.984 -8.07,-12.211 -5.551,-2.679 -12.269,-1.414 -16.371,3.086",
    style: {
      fill: "url(#linearGradient96)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g102",
    clipPath: "url(#clipPath106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 901.297,142.211 H 759.926 V 244.785 H 901.297 V 216.93 H 788.883 v -46.594 h 112.414 z m 0,177.293 V 291.383 H 759.926 v 28.121 h 141.371",
    style: {
      fill: "url(#linearGradient112)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g118",
    clipPath: "url(#clipPath122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1023.93,294.949 c -36.621,0 -66.309,-28.691 -66.309,-64.09 0,-35.398 29.688,-64.093 66.309,-64.093 36.62,0 66.31,28.695 66.31,64.093 0.05,35.348 -29.56,64.043 -66.13,64.09 -0.06,0 -0.12,0 -0.18,0 z m 96.45,-64.09 c 0,-51.492 -43.18,-93.23 -96.45,-93.23 -53.27,0 -96.453,41.738 -96.453,93.23 0,51.489 43.183,93.231 96.453,93.231 53.25,-0.051 96.4,-41.762 96.45,-93.231",
    style: {
      fill: "url(#linearGradient128)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g134",
    clipPath: "url(#clipPath138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1259.25,169.145 c 13.79,-0.571 25.45,9.773 26.04,23.101 0.59,13.328 -10.12,24.598 -23.91,25.168 -0.71,0.027 -1.42,0.027 -2.13,0 h -80.58 v -48.269 z m 0,150.359 c 29.14,0.035 52.79,-22.774 52.83,-50.938 0.02,-14.343 -6.21,-28.031 -17.17,-37.707 21.51,-19.004 23.01,-51.265 3.35,-72.054 -10.01,-10.586 -24.17,-16.61 -39.01,-16.594 h -94.54 c -7.69,0 -13.93,6.012 -13.95,13.445 v 75.203 c 0.02,7.438 6.25,13.461 13.95,13.489 h 94.54 c 13.78,0.015 24.93,10.824 24.91,24.14 -0.01,13.293 -11.16,24.067 -24.91,24.082 h -94.54 c -7.69,-0.425 -14.29,5.258 -14.73,12.696 -0.44,7.437 5.44,13.812 13.14,14.238 0.53,0.031 1.06,0.031 1.59,0 h 94.54",
    style: {
      fill: "url(#linearGradient144)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150",
    clipPath: "url(#clipPath154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1334.22,160.988 c 9.85,21.735 61.52,144.809 72.52,154.946 2.15,2.152 5.07,3.429 8.16,3.57 3.1,-0.121 6.02,-1.402 8.16,-3.57 11.04,-10.137 62.66,-133.211 72.51,-154.946 7.35,-16.218 -18.24,-26.933 -25.44,-10.754 l -55.23,121.84 -55.18,-121.84 c -7.35,-16.179 -32.84,-5.464 -25.5,10.754 v 0",
    style: {
      fill: "url(#linearGradient160)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g166",
    clipPath: "url(#clipPath170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1629.83,281.508 c -12.41,10.551 -28.54,16.09 -45.05,15.472 -5.27,-0.429 -10.41,-1.71 -15.24,-3.792 -4.05,-1.735 -7.64,-4.344 -10.49,-7.625 -4.2,-4.754 -6.18,-10.977 -5.47,-17.192 2.6,-14.195 22.26,-19.793 41.91,-25.082 32.52,-9.125 64.72,-17.984 60.79,-59.555 v -0.218 c -1.2,-8.786 -4.83,-17.094 -10.49,-24.071 -7.46,-8.465 -17.27,-14.703 -28.27,-17.984 -11.9,-3.438 -24.43,-4.313 -36.71,-2.555 -23.86,3.199 -46.29,12.86 -64.71,27.86 l 18.24,22.039 c 14.27,-11.43 31.54,-18.813 49.89,-21.336 8.13,-1.231 16.45,-0.719 24.35,1.5 5.55,1.476 10.49,4.554 14.18,8.816 2.32,2.649 3.78,5.899 4.2,9.344 1.28,17.633 -18.88,23.32 -39.58,29.137 -29.1,7.847 -58.42,16.222 -63.17,49.418 v 1.011 c -1.1,13.645 3.32,27.168 12.32,37.735 5.69,6.261 12.64,11.347 20.43,14.941 8.13,3.535 16.83,5.684 25.72,6.348 24.13,1.211 47.81,-6.692 66.03,-22.039 l -18.88,-22.172",
    style: {
      fill: "url(#linearGradient176)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path178"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g182",
    clipPath: "url(#clipPath186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g188",
    clipPath: "url(#clipPath192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1682,142 v 103 h 142 v -29 h -112 v -45 h 112 v -29 z m 0,178 h 142 v -29 h -142 z",
    style: {
      fill: "url(#linearGradient198)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path200"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeobase);
export default __webpack_public_path__ + "static/media/neobase.e534be596f67b7d670baaac49509c1e9.svg";
export { ForwardRef as ReactComponent };